import { Organization } from 'src/types'

import api, { make, Response } from '.'

export type GetOrganizationByCurrentManagerData = {
  organizations_current_manager: [
    {
      code: string
      legal_name: string
      organization_id: number
    }
  ]
}

type Data = {
  organization: Organization
}

async function getById(
  id: Organization['organization_id']
): Promise<Response<Organization>> {
  return make<Data, Organization>({
    axiosCall: api.get(`organizations/${id}`),
    transformData: data =>
      Object.assign(data.organization, {
        organization_id: Number(data.organization.organization_id)
      })
  })
}

async function getOrganizationByCurrentManager(): Promise<
  Response<GetOrganizationByCurrentManagerData>
> {
  return make<GetOrganizationByCurrentManagerData>({
    axiosCall: api.get('get_organization_by_current_manager')
  })
}

export default { getById, getOrganizationByCurrentManager }
